var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { FaSave, FaSearch, FaUndo } from 'react-icons/fa';
import { defineMessages, useIntl } from 'react-intl';
import EmployeeFilterService from '../services/EmployeeFilterService';
import ToastrService from '../services/ToastrService';
import { c } from '../utils/c';
import { dynamicSort } from '../utils/dynamicSort';
import { FilterSaveModal } from './FilterSaveModal';
var messages = defineMessages({
    SaveSearchCriteria: {
        id: 'SaveSearchCriteria',
        defaultMessage: 'Save search criteria',
    },
    RenameSearchCriteria: {
        id: 'RenameSearchCriteria',
        defaultMessage: 'Rename search criteria',
    },
    DeleteSearchCriteria: {
        id: 'DeleteSearchCriteria',
        defaultMessage: 'Delete search criteria',
    },
    SelectSearchCriteria: {
        id: 'SelectSearchCriteria',
        defaultMessage: 'Select search criteria',
    },
    ReplaceSearchCriteria: {
        id: 'ReplaceSearchCriteria',
        defaultMessage: 'Replace search criteria',
    },
    ResetFilters: {
        id: 'ResetFilters',
        defaultMessage: 'Reset filters',
    },
    SelectAll: {
        id: 'SelectAll',
        defaultMessage: 'Select all',
    },
    // Same labels used in AngularJS modal
    SearchCriteriaNameInputTitle: {
        id: 'SearchCriteriaNameInputTitle',
        defaultMessage: 'SearchCriteriaNameInputTitle',
    },
    SearchCriteriaNameInputMessage: {
        id: 'SearchCriteriaNameInputMessage',
        defaultMessage: 'SearchCriteriaNameInputMessage',
    },
    SearchCriteriaNameInputPlaceholder: {
        id: 'SearchCriteriaNameInputPlaceholder',
        defaultMessage: 'SearchCriteriaNameInputPlaceholder',
    },
});
export { messages };
export var FilterSave = function (_a) {
    var hasActiveFilters = _a.hasActiveFilters, screen = _a.screen, filtersObject = _a.filtersObject, resetFilters = _a.resetFilters, setFilter = _a.setFilter;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _b = useState([]), savedFilters = _b[0], setSavedFilters = _b[1];
    var _c = useState(false), isNameModalOpen = _c[0], setIsNameModalOpen = _c[1];
    var _d = useState(), modalFilter = _d[0], setModalFilter = _d[1];
    var hasSavedFilters = useMemo(function () { return savedFilters.length > 0; }, [savedFilters.length]);
    var selectedFilter = useMemo(function () {
        if (!hasSavedFilters) {
            return undefined;
        }
        return savedFilters.find(function (item) { return item.json === JSON.stringify(filtersObject); });
    }, [filtersObject, hasSavedFilters, savedFilters]);
    var reloadSavedFilters = useCallback(function () {
        setSavedFilters(EmployeeFilterService.getScreenFilters(screen)
            .map(function (x) { return (__assign(__assign({}, x), { filter: JSON.parse(x.json) || {} })); })
            .sort(dynamicSort('name')));
    }, [screen]);
    useEffect(function () {
        EmployeeFilterService.load().then(reloadSavedFilters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var showSaveFilterModal = function () {
        setModalFilter({
            name: '',
            filter: filtersObject,
            screen: screen,
            json: JSON.stringify(filtersObject),
        });
        setIsNameModalOpen(true);
    };
    var selectFilter = function (filterId) {
        var savedFilter = savedFilters.find(function (item) { return item.id === filterId; });
        if (savedFilter) {
            resetFilters();
            setFilter(savedFilter.filter);
        }
    };
    var replaceFilter = function (filter, event) { return __awaiter(void 0, void 0, void 0, function () {
        var model, updatedFilter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    event.preventDefault();
                    if (!filter || !filter.id)
                        return [2 /*return*/];
                    model = __assign(__assign({}, filter), { json: JSON.stringify(filtersObject) });
                    return [4 /*yield*/, EmployeeFilterService.setFilter(model)];
                case 1:
                    updatedFilter = _a.sent();
                    if (updatedFilter) {
                        ToastrService.changesSaved(intl);
                        reloadSavedFilters();
                    }
                    return [2 /*return*/, updatedFilter];
            }
        });
    }); };
    var showRenameFilterModal = function (filter, event) {
        event.stopPropagation();
        event.preventDefault();
        if (!filter || !filter.id)
            return;
        setModalFilter(filter);
        setIsNameModalOpen(true);
    };
    var deleteFilter = function (filter, event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    event.preventDefault();
                    if (!filter || !filter.id)
                        return [2 /*return*/];
                    return [4 /*yield*/, EmployeeFilterService.deleteFilter(filter)];
                case 1:
                    _a.sent();
                    ToastrService.changesSaved(intl);
                    reloadSavedFilters();
                    return [2 /*return*/];
            }
        });
    }); };
    var saveFilter = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedFilter;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = modalFilter === null || modalFilter === void 0 ? void 0 : modalFilter.name) === null || _a === void 0 ? void 0 : _a.length))
                        return [2 /*return*/];
                    return [4 /*yield*/, EmployeeFilterService.setFilter(modalFilter)];
                case 1:
                    updatedFilter = _b.sent();
                    if (updatedFilter) {
                        ToastrService.changesSaved(intl);
                        reloadSavedFilters();
                    }
                    setIsNameModalOpen(false);
                    setModalFilter(undefined);
                    return [2 /*return*/, updatedFilter];
            }
        });
    }); };
    if (!hasSavedFilters && hasActiveFilters) {
        return (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ type: "button", className: "btn btn-default", onClick: showSaveFilterModal }, { children: [_jsx(FaSave, { className: "react-icon fa-fw margin5R" }), formatMessage(messages.SaveSearchCriteria)] })), _jsx(FilterSaveModal, { isNameModalOpen: isNameModalOpen, modalFilter: modalFilter, saveFilter: saveFilter, setModalFilter: setModalFilter, setIsNameModalOpen: setIsNameModalOpen })] }));
    }
    if (hasSavedFilters) {
        return (_jsxs("div", __assign({ className: "btn-group" }, { children: [_jsx(FilterSaveModal, { isNameModalOpen: isNameModalOpen, modalFilter: modalFilter, saveFilter: saveFilter, setModalFilter: setModalFilter, setIsNameModalOpen: setIsNameModalOpen }), _jsxs("button", __assign({ type: "button", className: "btn btn-default dropdown-toggle", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" }, { children: [_jsx(FaSearch, { className: c('react-icon margin5R', selectedFilter ? 'text-success' : 'text-orange') }), selectedFilter && selectedFilter.name
                            ? selectedFilter.name
                            : formatMessage(messages.SelectSearchCriteria), _jsx("span", { className: "caret" })] })), _jsxs("ul", __assign({ className: "dropdown-menu" }, { children: [hasActiveFilters && !selectedFilter && (_jsx("li", { children: _jsxs("a", __assign({ onClick: showSaveFilterModal }, { children: [_jsx(FaSave, { className: "react-icon fa-fw margin5R" }), formatMessage(messages.SaveSearchCriteria)] })) })), hasActiveFilters && (_jsx("li", { children: _jsxs("a", __assign({ onClick: resetFilters }, { children: [_jsx(FaUndo, { className: "react-icon fa-fw margin5R" }), formatMessage(messages.ResetFilters)] })) })), hasActiveFilters && _jsx("li", { role: "separator", className: "divider" }), hasSavedFilters &&
                            savedFilters.map(function (filter) { return (_jsx("li", __assign({ className: c(selectedFilter && selectedFilter.id === filter.id && 'active') }, { children: _jsxs("a", __assign({ onClick: function () { return selectFilter(filter.id); }, id: filter.id }, { children: [_jsx("span", { children: filter.name }), !selectedFilter && hasActiveFilters && (_jsx("i", { className: "fa fa-exchange clickable", title: formatMessage(messages.ReplaceSearchCriteria), onClick: function (e) { return replaceFilter(filter, e); } })), _jsx("i", { className: "fa fa-pencil clickable", title: formatMessage(messages.RenameSearchCriteria), onClick: function (e) { return showRenameFilterModal(filter, e); } }), _jsx("i", { className: "fa fa-trash clickable", title: formatMessage(messages.DeleteSearchCriteria), onClick: function (e) { return deleteFilter(filter, e); } })] })) }), filter.id)); })] }))] })));
    }
    return null;
};
